// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"ce1e00ef","453":"82f51bd6"}[chunkId] + ".chunk.js";
};